/* eslint-disable arrow-body-style */
import { useNavigate, useParams } from 'react-router-dom'

import { ChangePwdSuccessIcon, ChangePwdWrongIcon } from 'assets/icons'
import { UserContext } from 'contexts/user'
import React, { useContext } from 'react'

import ChangePwdResult from './ChangePwdResult'

const RecoveryPwdResults = () => {
  const RecoveryPwdResultsRoutes = {
    changePwdSuccess: 'contrasena-modificada',
    changePwdError: 'error-contrasena-modificada'
  }

  const { method } = useParams()

  return (
    <>
      <header className='w-full h-14 bg-white flex items-center justify-center font-bold'>
        <h1>Cambiar contraseña</h1>
      </header>
      <section className='flex h-[80vh] w-full mx-auto md:max-w-564 md:flex md:items-end md:flex-col px-4'>
        {method === RecoveryPwdResultsRoutes.changePwdSuccess && (
          <ChangePwdSuccess />
        )}
        {method === RecoveryPwdResultsRoutes.changePwdError && (
          <ChangePwdError />
        )}
      </section>
    </>
  )
}

export default RecoveryPwdResults

const ChangePwdSuccess = () => {
  const { logout } = useContext(UserContext)

  return (
    <ChangePwdResult
      icon={<ChangePwdSuccessIcon />}
      onClick={() => logout()}
      pwdModified='¡Se ha modificado correctamente la contraseña en tu billetera!'
    />
  )
}

const ChangePwdError = () => {
  const navigate = useNavigate()

  return (
    <ChangePwdResult
      onClick={() => navigate('/configuracion', { replace: true })}
      icon={<ChangePwdWrongIcon />}
      pwdModified='¡No hemos podido modificar tu contraseña, volve a intentarlo en unos minutos! '
    />
  )
}
